function getCompQty(variantId) {
  // pehle variant id se try karo
  var input = document.querySelector('.comp-qty-input[data-variant-id="' + variantId + '"]');
  if (input) return parseInt(input.value) || 1;

  // agar na mile, to checkbox ke same card ke andar wala qty box dhoondo
  var checkbox = document.querySelector('.comp-card-add-checkbox[data-variant-id="' + variantId + '"]');
  if (checkbox) {
    var card = checkbox.closest('[data-comp-card]');
    if (card) {
      var qtyInput = card.querySelector('.comp-qty-input');
      if (qtyInput) return parseInt(qtyInput.value) || 1;
    }
  }
  return 1;
}

async function AddCardProduct(variantId) {
  let qty = getCompQty(variantId);
  let response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: variantId, quantity: qty }),
  });
  if (!response.ok) throw new Error("Failed to add product to cart.");
}
async function RemoveCardProduct(variantId) {
  let response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 0 }),
  });
  if (!response.ok) throw new Error("Failed to remove product from cart.");
}

// ✅ Checkbox
window.handleCompCardClick = async function(checkbox) {
  let variantId = checkbox.getAttribute("data-variant-id");
  let buttonStatus = checkbox.getAttribute("data-button-status");

  if (buttonStatus === "add") {
    checkbox.checked = true;
    checkbox.setAttribute("data-button-status", "remove");
    syncPopupCta(variantId, "remove");
    AddCardProduct(variantId).catch(() => {
      checkbox.checked = false;
      checkbox.setAttribute("data-button-status", "add");
      syncPopupCta(variantId, "add");
    });

  } else if (buttonStatus === "remove") {
    checkbox.checked = false;
    checkbox.setAttribute("data-button-status", "add");
    syncPopupCta(variantId, "add");
    RemoveCardProduct(variantId).catch(() => {
      checkbox.checked = true;
      checkbox.setAttribute("data-button-status", "remove");
      syncPopupCta(variantId, "remove");
    });
  }
};
// ✅ Popup Button
window.handlePopupCtaClick = async function(button) {
  let variantId = button.getAttribute("data-variant-id");
  let buttonStatus = button.getAttribute("data-button-status");
  button.disabled = true;
  let addText = button.querySelector(".button_add_text");
  let removeText = button.querySelector(".button_remove_text");
  let spinner = button.querySelector(".comp-card-loading-spinner");
  if (spinner) spinner.style.display = "inline-block";
  if (addText) addText.classList.add("d-none");
  if (removeText) removeText.classList.add("d-none");
  try {
    if (buttonStatus === "add") {
      try {
        await AddCardProduct(variantId);
        button.setAttribute("data-button-status", "remove");
        if (addText) addText.classList.add("d-none");
        if (removeText) removeText.classList.remove("d-none");
        syncCardCheckbox(variantId, "remove", true);
      } catch (error) {
        console.error("Error adding:", error);
        if (addText) addText.classList.remove("d-none");
      }
    } else if (buttonStatus === "remove") {
      try {
        await RemoveCardProduct(variantId);
        button.setAttribute("data-button-status", "add");
        if (addText) addText.classList.remove("d-none");
        if (removeText) removeText.classList.add("d-none");
        syncCardCheckbox(variantId, "add", false);
      } catch (error) {
        console.error("Error removing:", error);
        if (removeText) removeText.classList.remove("d-none");
      }
    }
  } finally {
    button.disabled = false;
    if (spinner) spinner.style.display = "none";
  }
};

function syncPopupCta(variantId, newStatus) {
  var popupCta = document.getElementById("compPopupCta");
  if (popupCta && popupCta.getAttribute("data-variant-id") == variantId) {
    popupCta.setAttribute("data-button-status", newStatus);
    var addText = popupCta.querySelector(".button_add_text");
    var removeText = popupCta.querySelector(".button_remove_text");
    if (newStatus === "remove") {
      if (addText) addText.classList.add("d-none");
      if (removeText) removeText.classList.remove("d-none");
    } else {
      if (addText) addText.classList.remove("d-none");
      if (removeText) removeText.classList.add("d-none");
    }
  }
}

function syncCardCheckbox(variantId, newStatus, isChecked) {
  var checkboxes = document.querySelectorAll(".comp-card-add-checkbox");
  checkboxes.forEach(function (cb) {
    if (cb.getAttribute("data-variant-id") == variantId) {
      cb.setAttribute("data-button-status", newStatus);
      cb.checked = isChecked;
    }
  });
}

(function () {
  function getMainColor() {
    var radio = document.querySelector('product-info input[name="Color"]:checked');
    return radio ? radio.value.trim() : null;
  }

  function variantsOf(card) {
    var el = card.querySelector(".comp-card-variants");
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function matchVariant(card, color) {
    var vs = variantsOf(card);
    if (!vs.length) return null;
    if (color) {
      var c = color.trim().toLowerCase();
      var hit = vs.find(function (v) { return v.color && v.color.trim().toLowerCase() === c; });
      if (hit) return hit;
      hit = vs.find(function (v) { return v.color && v.color.trim().toLowerCase().indexOf(c) === 0; });
      if (hit) return hit;
      hit = vs.find(function (v) { return v.color && v.color.trim().toLowerCase().indexOf(c) !== -1; });
      if (hit) return hit;
    }
    var def = card.getAttribute("data-default-id");
    return vs.find(function (v) { return String(v.id) === String(def); }) || vs[0];
  }

  async function getCartVariantIds() {
    try {
      var res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!res.ok) return new Set();
      var cart = await res.json();
      return new Set(cart.items.map(function (i) { return i.variant_id; }));
    } catch (e) { return new Set(); }
  }

  async function refresh() {
    var cards = document.querySelectorAll("[data-comp-card]");
    if (!cards.length) return;
    var color = getMainColor();
    var cartIds = await getCartVariantIds();
    cards.forEach(function (card) {
      var v = matchVariant(card, color);
      if (!v) return;
      var img = card.querySelector(".comp-card-image img");
      if (img && v.image) img.src = v.image;
      var checkbox = card.querySelector(".comp-card-add-checkbox");
      if (checkbox) {
        checkbox.setAttribute("data-variant-id", v.id);
        checkbox.checked = cartIds.has(Number(v.id));
        checkbox.setAttribute("data-button-status", cartIds.has(Number(v.id)) ? "remove" : "add");
      }
    });
  }

  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "Color") refresh();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh);
  } else {
    refresh();
  }
})();



function changeCompQty(btn, delta) {
  const wrapper = btn.closest('.comp-qty-wrapper');
  const input = wrapper.querySelector('.comp-qty-input');
  let val = parseInt(input.value) || 1;
  val = Math.max(1, Math.min(99, val + delta));
  input.value = val;
  syncCompQty(input);
}

function syncCompQty(input) {
  const variantId = input.dataset.variantId;
  const qty = parseInt(input.value) || 1;

  // Store quantity so handleCompCardClick can use it
  input.closest('.comp-qty-wrapper').dataset.qty = qty;

  // If already added to cart, update cart line quantity live
  updateCartLineQty(variantId, qty);
}

function updateCartLineQty(variantId, qty) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const line = cart.items.findIndex(item => item.variant_id == variantId);
      if (line === -1) return; // not in cart yet, quantity will be used on add

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line + 1, quantity: qty })
      })
      .then(res => res.json())
      .then(() => {
        // Refresh cart UI if your theme has a drawer/cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
    });
}